const resources = {
    sponsored: 'Commandité',
    alt: 'Image de bannière avec contenu commandité',
    featuredProduct: 'Produits en vedette'
};

export default function getResource(label) {
    return resources[label];
}
